import { render, staticRenderFns } from "./CreateNewBannerTab.vue?vue&type=template&id=d4a8c760"
import script from "./CreateNewBannerTab.vue?vue&type=script&lang=js"
export * from "./CreateNewBannerTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports